import React from "react";
import { Box, Switch, Typography, useTheme } from "@mui/material";

interface ToggleSectionProps {
  question: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  noLabel: string;
  yesLabel: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

const ToggleSection: React.FC<ToggleSectionProps> = ({
  question,
  description,
  checked,
  onChange,
  noLabel,
  yesLabel,
  children,
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          {question}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: checked ? 400 : 600,
              color: theme.palette.text.primary,
            }}
          >
            {noLabel}
          </Typography>
          <Switch
            checked={checked}
            disabled={disabled}
            onChange={(_, next) => onChange(next)}
          />
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: checked ? 600 : 400,
              color: checked
                ? theme.palette.primary.main
                : theme.palette.text.primary,
            }}
          >
            {yesLabel}
          </Typography>
        </Box>
      </Box>
      {description && (
        <Typography
          sx={{
            fontSize: "13px",
            color: theme.palette.text.primary,
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default ToggleSection;
